export default "__VITE_ASSET__ba1636f0__"